// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"20a30040","247":"bd081063","484":"8add5c3b","627":"07a7b865","643":"735e35c1","707":"a7971f23","834":"1e4320be","851":"84acd8d0","867":"643e3ff8","923":"7d4f6d77","938":"4c06d152"}[chunkId] + ".chunk.js";
};